export const CHANGE_TOP_DISCOUNT_FIELD = 'CHANGE_TOP_DISCOUNT_FIELD';
export const GET_SETTING_TOP_DISCOUNT = 'GET_SETTING_TOP_DISCOUNT';
export const GET_SETTING_TOP_DISCOUNT_RESULT = 'GET_SETTING_TOP_DISCOUNT_RESULT';
export const SAVE_SETTING_TOP_DISCOUNT = 'SAVE_SETTING_TOP_DISCOUNT';
export const SAVE_SETTING_TOP_DISCOUNT_RESULT = 'SAVE_SETTING_TOP_DISCOUNT_RESULT';
export const CLEAR_DATA_TOP_DISCOUNT = 'CLEAR_DATA_TOP_DISCOUNT';
export const CHANGE_LIST_RECOMMEND_POPUP_PRODUCT_RESULT =
  'CHANGE_LIST_RECOMMEND_POPUP_PRODUCT_RESULT';
export const GET_LIST_PRODUCTS_DETAIL_RESULT = 'GET_LIST_PRODUCTS_DETAIL_RESULT';
export const GET_LIST_PRODUCTS_DETAIL = 'GET_LIST_PRODUCTS_DETAIL';
export const ADD_PRODUCT_TOP_DISCOUNT = 'ADD_PRODUCT_TOP_DISCOUNT';
export const REMOVE_PRODUCT_TOP_DISCOUNT = 'REMOVE_PRODUCT_TOP_DISCOUNT';
export const CHANGE_TOP_DISCOUNT_SETTINGS = 'CHANGE_TOP_DISCOUNT_SETTINGS';
export const CHANGE_TOP_DISCOUNT_THEME = 'CHANGE_TOP_DISCOUNT_THEME';
